import FormattedMessage from 'I18n/components/FormattedMessage';
import { HubMerchCardLayoutUI } from '../../containers/merch-card/HubMerchCardLayoutUI';
import { StarterLowerTierMessage } from '../../containers/merch-card/StarterLowerTierMessage';
import { useIsFreePortal } from '../../hooks/inventory/useProductInventory';
import { jsx as _jsx } from "react/jsx-runtime";
export const SalesHubMerchCards = () => {
  const {
    isFreePortal,
    loading
  } = useIsFreePortal();
  const productsConfig = {
    STARTER: {
      apiName: 'sales-hub-starter',
      Subheading: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-pages-ui.merchCardsV2.sales.starterCard.description"
      }),
      lowerTierMessage: StarterLowerTierMessage({
        isFreePortal,
        loading
      })
    },
    PROFESSIONAL: {
      apiName: 'sales-hub-professional',
      Subheading: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-pages-ui.merchCardsV2.sales.professionalCard.description"
      }),
      lowerTierMessage: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-pages-ui.merchCardsV2.priorityFeatures.productLevels.sales.professional.lowerTierPlus"
      })
    },
    ENTERPRISE: {
      apiName: 'sales-hub-enterprise',
      Subheading: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-pages-ui.merchCardsV2.sales.enterpriseCard.description"
      }),
      lowerTierMessage: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-pages-ui.merchCardsV2.priorityFeatures.productLevels.sales.enterprise.lowerTierPlus"
      })
    }
  };
  return /*#__PURE__*/_jsx(HubMerchCardLayoutUI, {
    productsConfig: productsConfig
  });
};